<template>
  <div :class="[{ '--feed': isFeed }, 'message__footer ']">
    <reply-thread
      :is-feed="isFeed"
      :is-self="isSelf"
      :is-comment="isComment"
      :message="message"
    />
    <feed-like
      v-if="isFeed"
      :message="message"
      :is-liked="isLiked"
      @like="() => $emit('like')"
      @unlike="() => $emit('unlike')"
    />
  </div>
</template>

<script>
export default {
  components: {
    ReplyThread: () => import("@/components/message-thread/ReplyThread"),
    FeedLike: () => import("@/components/message-thread/FeedLike")
  },

  props: {
    message: { type: Object, required: true },
    isLiked: { type: Boolean, default: false },
    isFeed: { type: Boolean, default: false },
    isComment: { type: Boolean, default: false },
    isSelf: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.message__footer {
  &.--feed {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $size--2 $size--3 0;
    margin: 0 -#{$size--3};
    border-top: 1px solid $color-ui--grey-20;
  }
}
</style>
